'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var BASE_URL = '/_api/cloud-data/v1/external-database-connections';

var handleSuccess = function handleSuccess(response) {
  return response.data;
};

var handleError = function handleError(error) {
  var response = error.response;
  if (response && response.data && response.data.message) {
    return Promise.reject(new Error(response.data.message));
  }
  return Promise.reject(error);
};

var formatConnector = function formatConnector(_ref) {
  var name = _ref.name,
      endpoint = _ref.endpoint,
      configuration = _ref.configuration;
  return {
    namespace: name,
    endpoint: endpoint,
    configuration: configuration
  };
};

var WixDataConnectorSettings = exports.WixDataConnectorSettings = function () {
  function WixDataConnectorSettings(httpClient, signedInstance, options) {
    _classCallCheck(this, WixDataConnectorSettings);

    this.httpClient = httpClient;
    this.headers = { 'authorization': signedInstance };
    this.baseUrl = options && options.baseUrl || BASE_URL;
  }

  _createClass(WixDataConnectorSettings, [{
    key: 'getConnector',
    value: function getConnector(name) {
      return this._get(name).then(function (_) {
        return formatConnector(_.externalDatabaseConnection);
      });
    }
  }, {
    key: 'getAllConnectors',
    value: function getAllConnectors() {
      return this._get('').then(function (_) {
        return _.externalDatabaseConnections.map(formatConnector);
      });
    }
  }, {
    key: 'registerConnector',
    value: function registerConnector(_ref2) {
      var namespace = _ref2.namespace,
          endpoint = _ref2.endpoint,
          _ref2$configuration = _ref2.configuration,
          configuration = _ref2$configuration === undefined ? {} : _ref2$configuration;

      var params = {
        externalDatabaseConnection: { name: namespace, endpoint: endpoint, configuration: configuration }
      };
      return this._post('', params).then(function (_) {
        return formatConnector(_.externalDatabaseConnection);
      });
    }
  }, {
    key: 'modifyConnector',
    value: function modifyConnector(_ref3) {
      var namespace = _ref3.namespace,
          endpoint = _ref3.endpoint,
          _ref3$configuration = _ref3.configuration,
          configuration = _ref3$configuration === undefined ? {} : _ref3$configuration;

      var params = {
        externalDatabaseConnection: { endpoint: endpoint, configuration: configuration }
      };
      return this._put(namespace, params).then(function (_) {
        return formatConnector(_.externalDatabaseConnection);
      });
    }
  }, {
    key: 'unregisterConnector',
    value: function unregisterConnector(name) {
      return this._delete(name);
    }
  }, {
    key: '_get',
    value: function _get(path) {
      return this._httpRequest({
        url: path,
        method: 'get'
      });
    }
  }, {
    key: '_post',
    value: function _post(path, params) {
      return this._httpRequest({
        url: path,
        method: 'post',
        data: params
      });
    }
  }, {
    key: '_put',
    value: function _put(path, params) {
      return this._httpRequest({
        url: path,
        method: 'put',
        data: params
      });
    }
  }, {
    key: '_delete',
    value: function _delete(path) {
      return this._httpRequest({
        url: path,
        method: 'delete'
      });
    }
  }, {
    key: '_httpRequest',
    value: function _httpRequest(request) {
      return this.httpClient.request(Object.assign({
        baseURL: this.baseUrl,
        headers: this.headers
      }, request)).then(handleSuccess).catch(handleError);
    }
  }]);

  return WixDataConnectorSettings;
}();